import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_ratetype'

  static get fields () {
    return {
      id: new UUID(),
      short: new STRING(),
      full: new STRING(),
      desc: new STRING()
    }
  }
}
